// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.app-update-notification[data-v-0640cabe] {\n\tz-index: 10001;\n}\n.app-update-notification[data-v-0640cabe] .v-snack__wrapper {\n\tborder-radius: 12px;\n\tmin-width: 340px;\n}\n.app-update-notification[data-v-0640cabe] .v-snack__content {\n\tpadding: 16px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
